// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080805/js/" + chunkId + "." + {"44":"df276a12","225":"2b376dc5","481":"91183580","486":"4afbad47","770":"b31c5790"}[chunkId] + ".0.0718349202808013.chunk.js";
};